<template>
  <div class="!pt-3">
    <el-form ref="formRef" :model="field" :rules="rules">
      <!-- Title and Description -->
      <title-and-description :field="field" />
      <el-row :gutter="20" class="!mt-2" style="align-items: center">
        <el-col :span="12" class="!mb-3">
          <el-form-item size="mini" prop="slot_settings.startTime">
            <label
              class="field-title-label !text-black-600 !text-xs 2xl:!text-sm !font-normal block !mb-1"
            >
              Start Time
            </label>
            <el-select
              v-model="field.slot_settings.startTime"
              placeholder="Select Start Time"
              style="width: 100%"
              size="mini"
              clearable
            >
              <el-option
                v-for="template in showDateAndTimeFields"
                :key="template._id"
                :label="template.label"
                :value="template.key"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12" class="!mb-3">
          <el-form-item size="mini" prop="slot_settings.endTime">
            <label
              class="field-title-label !text-black-600 !text-xs 2xl:!text-sm !font-normal block !mb-1"
            >
              End Time
            </label>

            <el-select
              v-model="field.slot_settings.endTime"
              placeholder="Select End Time"
              style="width: 100%"
              size="mini"
              clearable
            >
              <el-option
                v-for="template in showDateAndTimeFields"
                :key="template._id"
                :label="template.label"
                :value="template.key"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12" class="!mb-3">
          <el-form-item size="mini" prop="slot_settings.slotDuration" class="!mb-1">
            <label
              class="field-title-label !text-black-600 !text-xs 2xl:!text-sm !font-normal block !mb-1"
            >
              Slot Duration (in minutes)
            </label>
            <!-- Checkbox toggle -->
            <el-checkbox v-model="useTemplateSlotDuration" size="mini" style="display: block">
              Select from Template
            </el-checkbox>
            <!-- Dropdown: shown only if checkbox is true -->
            <el-select
              v-if="useTemplateSlotDuration"
              v-model="field.slot_settings.slotDuration"
              placeholder="Select field from template"
              style="width: 100%"
              filterable
              clearable
              size="mini"
            >
              <el-option
                v-for="template in showNumberFields"
                :key="template._id"
                :label="template.label"
                :value="template.key"
              />
            </el-select>
            <!-- Manual Input: shown only if checkbox is false -->
            <el-input
              v-else
              :value="field.slot_settings.slotDuration"
              type="number"
              placeholder="Enter fixed value"
              size="mini"
              style="width: 100%; margin-top: 2px"
              @input="(val) => onManualInputChangeSlot(val, 'slotDuration')"
            />
          </el-form-item>
          <div class="text-[#F2994A] font-normal text-xs xl:text-smd 2xl:!text-sm">
            <span class="font-medium">Note</span>
            : This value will be used to calculate slot duration.
          </div>
        </el-col>
        <el-col :span="12" class="!mb-3">
          <el-form-item size="mini" prop="slot_settings.bufferTime" class="!mb-1">
            <label
              class="field-title-label !text-black-600 !text-xs 2xl:!text-sm !font-normal block !mb-1"
            >
              Buffer Time (in minutes)
            </label>
            <!-- Checkbox toggle -->
            <el-checkbox v-model="useTemplateBufferTime" size="mini" style="display: block">
              Select from Template
            </el-checkbox>
            <!-- Dropdown: shown only if checkbox is true -->
            <el-select
              v-if="useTemplateBufferTime"
              v-model="field.slot_settings.bufferTime"
              placeholder="Select field from template"
              style="width: 100%"
              filterable
              clearable
              size="mini"
            >
              <el-option
                v-for="template in showNumberFields"
                :key="template._id"
                :label="template.label"
                :value="template.key"
              />
            </el-select>
            <!-- Manual Input: shown only if checkbox is false -->
            <el-input
              v-else
              :value="field.slot_settings.bufferTime"
              type="number"
              placeholder="Enter fixed value"
              size="mini"
              style="width: 100%; margin-top: 2px"
              @input="(val) => onManualInputChangeSlot(val, 'bufferTime')"
            />
          </el-form-item>
          <div class="text-[#F2994A] font-normal text-xs xl:text-smd 2xl:!text-sm">
            <span class="font-medium">Note</span>
            : This value will be used to differentiate the slots.
          </div>
        </el-col>
        <el-col :span="12" class="!mb-3">
          <el-form-item size="mini" prop="slot_settings.appointment_date">
            <label
              class="field-title-label !text-black-600 !text-xs 2xl:!text-sm !font-normal block !mb-1"
            >
              Appointment Date
            </label>
            <el-select
              v-model="field.slot_settings.appointment_date"
              placeholder="Select Appointment Date "
              style="width: 100%"
              size="mini"
              clearable
            >
              <el-option
                v-for="template in showDateFields"
                :key="template._id"
                :label="template.label"
                :value="template.key"
              />
            </el-select>
          </el-form-item>
          <el-form-item style="margin-top: 20px">
            <el-checkbox v-model="field.properties.allow_user_to_reschedule">
              Allow User to Reschedule
            </el-checkbox>
          </el-form-item>
        </el-col>
        <el-col :span="12" class="!mb-3">
          <el-form-item size="mini" prop="slot_settings.dependencyFields">
            <label
              class="field-title-label !text-black-600 !text-xs 2xl:!text-sm !font-normal block !mb-1"
            >
              Dependency Fields
            </label>
            <el-select
              v-model="field.slot_settings.dependencyFields"
              placeholder="Select Dependency Fields"
              style="width: 100%"
              size="mini"
              clearable
              multiple
              filterable
            >
              <el-option
                v-for="template in showEntityFields"
                :key="template._id"
                :label="template.label"
                :value="template.key"
              />
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>

<script>
  export default {
    components: {
      TitleAndDescription: () => import('./TitleAndDescription'),
    },
    props: ['field', 'templatesData', 'selfTemplate', 'selfTemplateId', 'isFromDocument'],

    data() {
      return {
        appointment_date: '',
        slotDuration: '',
        manualslotDuration: null,
        rules: {
          'slot_settings.startTime': [
            {
              required: true,
              message: 'Start Time is required',
              trigger: 'change',
            },
          ],
          'slot_settings.endTime': [
            {
              required: true,
              message: 'End Time is required',
              trigger: 'change',
            },
          ],
          'slot_settings.slotDuration': [
            {
              required: true,
              message: 'Slot Duration is required',
              trigger: 'change',
            },
          ],
          // "slot_settings.bufferTime": [
          //   {
          //     required: true,
          //     message: "Buffer Time is required",
          //     trigger: "change",
          //   },
          // ],
          'slot_settings.appointment_date': [
            {
              required: true,
              message: 'Appointment Date is required',
              trigger: 'change',
            },
          ],
          // "slot_settings.dependencyFields": [
          //   {
          //     required: true,
          //     type: "array",
          //     min: 1,
          //     message: "At least one Dependency Field is required",
          //     trigger: "change",
          //   },
          //],
        },
        //useTemplateSlotDuration: false,
        //useTemplateBufferTime: false,
      };
    },
    mounted() {
      this.appointment_date = this.field?.slot_settings?.appointment_date;
      this.slotDuration = this.field?.slot_settings?.slotDuration;
      // this.useTemplateBufferTime =
      //   this.field?.slot_settings?.useTemplateBufferTime;
      // this.useTemplateSlotDuration =
      //   this.field?.slot_settings?.useTemplateSlotDuration;
    },
    computed: {
      showEntityFields() {
        let inputTypes = ['ENTITY', 'SELECT'];
        let filteredFields = this.selfTemplate.filter(
          (field) => this.field.key !== field.key && inputTypes.includes(field.inputType)
        );
        return filteredFields;
      },
      showNumberFields() {
        let inputTypes = ['NUMBER'];
        let filteredFields = this.selfTemplate.filter(
          (field) => this.field.key !== field.key && inputTypes.includes(field.inputType)
        );
        return filteredFields;
      },
      showDateFields() {
        let inputTypes = ['DATE'];

        let filteredFields = this.selfTemplate.filter(
          (field) => this.field.key !== field.key && inputTypes.includes(field.inputType)
        );
        return filteredFields;
      },
      showDateAndTimeFields() {
        let inputTypes = ['DATE_TIME', 'TIME'];
        let filteredFields = this.selfTemplate.filter(
          (field) => this.field.key !== field.key && inputTypes.includes(field.inputType)
        );
        return filteredFields;
      },
      dropdownDurationSelected() {
        return (
          !!this.field.slot_settings.slotDuration &&
          typeof this.field.slot_settings.slotDuration === 'string'
        );
      },
      // Disable dropdown if manual value is entered
      manualDurationEntered() {
        return !!this.manualslotDuration && typeof this.manualslotDuration === 'number';
      },
      useTemplateBufferTime: {
        get() {
          return this.field?.slot_settings?.useTemplateBufferTime || false;
        },
        set(val) {
          this.field.slot_settings.useTemplateBufferTime = val;
        },
      },
      useTemplateSlotDuration: {
        get() {
          return this.field?.slot_settings?.useTemplateSlotDuration || false;
        },
        set(val) {
          this.field.slot_settings.useTemplateSlotDuration = val;
        },
      },
    },
    methods: {
      // isManualInputSlot(key) {
      //   const val = this.field.slot_settings[key];
      //   return typeof val === "number" && !isNaN(val);
      // },
      // isSelectInputSlot(key) {
      //   const val = this.field.slot_settings[key];
      //   return typeof val === "string" && val !== "";
      // },
      onManualInputChangeSlot(val, key) {
        if (val === '' || val === null) {
          this.$set(this.field.slot_settings, key, '');
        } else {
          const num = Number(val);
          if (!isNaN(num)) {
            this.$set(this.field.slot_settings, key, num || 0);
          }
        }
      },
    },
  };
</script>
